import { PaymentModule } from "../enums";

export class InitPaymentModel {
    type: PaymentModule;
    data: any;
    isMultiPayments = true;
    isFromNotification = false;
}